import { Box, Typography } from "@mui/material"
import { AppColors } from "resources/AppColors"

function NoDataTableBody({ entity, firstVisitMessage, noDataMessage }) {
  return (
    <Box
      p={10}
      textAlign="center"
      bgcolor={"white"}
      sx={{ borderBottom: "1px solid rgba(224, 224, 224, 1)" }}
    >
      <Typography variant="title_bold" sx={{ color: AppColors.PRIMARY }}>
        {entity ?
          noDataMessage
          :
          firstVisitMessage
        }
      </Typography>
    </Box>
  )
}

export default NoDataTableBody